import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { DocumentDetailContext } from "../contexts/DocumentDetailContext";
import { EditRowItem, RowItem, TableHeader } from "./Components";
import "./Extraction.css";
import { Add } from "@mui/icons-material";


let allNormalizedKeys = ["Patient Name", "Patient Date of Birth", "To", "Address", "Phone Number"];

let dataExtractKeysList = {
    "Patient Name": "patientName",
    "Patient Date of Birth": "dateOfBirth",
    "Address": "address",
    "Phone Number": "phone_number",
    "To": "provider_details",
}

const Extraction = (props) => {

    const { data = {}, setDocumentData, duplicateDocumentView, setDataSave, isSave, previousData } = useContext(DocumentDetailContext);
    const [extractionData, setExtractionData] = useState([]);
    const [extractionKeys, setExtractionKeys] = useState([]);
    const [selectedObj, setSelectedObj] = useState({});
    const [isFieldModified, setFieldModify] = useState(false);

    useEffect(() => {
        let extraction = JSON.parse(JSON.stringify(data?.Entity_Details?.extraction || {}))
        let availableKeys = Object.keys(extraction).map(m => extraction[m].normalized);
        let finalData = allNormalizedKeys.reduce((acc, m) => {
            if (Object.hasOwn(extraction, dataExtractKeysList[m])) {
                let temp = { ...extraction[dataExtractKeysList[m]], id: dataExtractKeysList[m] }
                acc.push(temp);
            }
            return acc;
        }, []);
        setExtractionKeys([...availableKeys]);
        setExtractionData(JSON.parse(JSON.stringify(finalData)));
    }, [data]);

    useEffect(() => {
        if(isFieldModified && !isSave) {
            setFieldModify(false);
            setSelectedObj(false);
        }
    }, [isSave])


    const handleEdit = (row) => {
        setSelectedObj({ ...row });
    }

    const handleChange = (key, obj) => {
        let res = JSON.parse(JSON.stringify(data));
        if (selectedObj.id != dataExtractKeysList[obj.normalized]) {
            if(key) delete res.Entity_Details.extraction[key];
            res.Entity_Details.extraction[dataExtractKeysList[obj.normalized]] = { ...obj, id:  dataExtractKeysList[obj.normalized] };
            setSelectedObj({...obj, id:  dataExtractKeysList[obj.normalized]})
        } else {
            res.Entity_Details.extraction[key] = { ...obj };
            setSelectedObj({...obj, })
        }
        setDataSave(true);
        setDocumentData(JSON.parse(JSON.stringify(res)));
        setFieldModify(true);
    }

    const handleCancel = () => {
        let tempData = {...data};
        let extraction = tempData.Entity_Details.extraction;
        extraction[selectedObj.id] = previousData.Entity_Details.extraction[selectedObj.id];
        tempData.Entity_Details.extraction = {...extraction};
        setDocumentData(JSON.parse(JSON.stringify(tempData)));
        setSelectedObj({});
    }

    const addNewItem = () => {
        let temp = [...extractionData];
        temp.push({
            normalized: "",
            confidence: 1.0,
            key: "",
            value: "",
            modified: true,
        });
        setExtractionData([...temp]);
        setSelectedObj(temp)
    }

    return <div className="specific-extraction" style={{ marginBottom: "20px" }}>
        <div className="extraction-table-title">Extracted Information</div>
        <TableContainer sx={{ boxShadow: "0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)" }}>
            <Table aria-label="simple table">
                <TableHead>
                    <TableHeader />
                </TableHead>
                <TableBody>
                    {extractionData.map((row) => (
                        selectedObj.id == row.id ?
                            <EditRowItem
                                handleChange={handleChange}
                                data={row}
                                availableOptions={extractionKeys}
                                keyOrders={allNormalizedKeys}
                                documentData={data}
                                isSave={isSave}
                                handleCancel={handleCancel}
                            /> : <RowItem data={row} handleEdit={() => handleEdit(row)} />
                    ))}
                </TableBody>
            </Table>
            {extractionKeys?.length != allNormalizedKeys?.length && extractionData[extractionData?.length - 1]?.normalized && <div className="add-new-item" onClick={addNewItem}>
                <Add />
                <div>Add New Key/Parameter</div>
            </div>}
        </TableContainer>
    </div>
}

export default Extraction;